import DatePicker from "./DatePicker.vue";
import { pluginify } from "./../../util";
export default pluginify(DatePicker);
export { DatePicker };
